<div
  class="border day d-flex flex-column mb-1 h-100"
  [class.bbl]="isBottomLeft()"
  [class.is-today]="isToday"
  [class.day-off]="isDayOff"
>
  <div
    class="bg-light d-flex text-primary p-1 day-header border-bottom text-nowrap"
  >
    @if(plan(); as plan) {
    <a [routerLink]="['/learn/plan', plan.plan_id]">{{
      day().toDate() | date : "ccc, LLL d"
    }}</a>
    } @else {
    {{ day().toDate() | date : "ccc, LLL d" }}
    }
  </div>
  <div
    class="flex-grow-1 p-1 plan-content"
    [class.empty-plan]="!plan()?.content"
  >
    @if(plan(); as plan) {
    <a [routerLink]="['/learn/plan', plan.plan_id]" class="d-block text-decoration-none text-dark h-100">
      <fk-mdv
        [content]="plan.content"
        class="mb-3 jax-plan jax-plan-sm pointer-block"
      ></fk-mdv>
    </a>
    } @else {
    <div
      class="text-center h-100 d-flex align-items-center justify-content-center"
    >
      <small class="text-muted"><em>No plan</em></small>
    </div>
    }
  </div>
</div>
